var _mask, _g, _g2, _g3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgHomeSection2Icon1 = function SvgHomeSection2Icon1(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    fill: "none",
    height: 80,
    width: 150,
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _mask || (_mask = /*#__PURE__*/React.createElement("mask", {
    id: "home-section2-icon-1_svg__a",
    height: 12,
    maskUnits: "userSpaceOnUse",
    width: 51,
    x: 29,
    y: 61
  }, /*#__PURE__*/React.createElement("path", {
    clipRule: "evenodd",
    d: "M29.375 61.565h50.04V72.29h-50.04z",
    fill: "#fff",
    fillRule: "evenodd"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipRule: "evenodd",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M53.08 62.828H35.677a.864.864 0 0 1-.864-.865V60.92c0-.477.387-.864.864-.864h17.405c.477 0 .864.387.864.864v1.044a.864.864 0 0 1-.864.865z",
    fill: "#9049ff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M53.08 60.054H35.677a.864.864 0 0 1-.864-.864v-1.044c0-.477.387-.865.864-.865h17.405c.477 0 .864.388.864.865v1.044a.864.864 0 0 1-.864.864z",
    fill: "#6400ff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M53.08 57.28H35.677a.864.864 0 0 1-.864-.863v-1.045c0-.477.387-.864.864-.864h17.405c.477 0 .864.387.864.864v1.045a.864.864 0 0 1-.864.864z",
    fill: "#9049ff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M87.542 9.375H43.476c-.848 0-1.536.688-1.536 1.536v59.833c0 .848.688 1.536 1.536 1.536h35.651c5.496 0 9.951-4.456 9.951-9.951V10.91c0-.849-.688-1.536-1.536-1.536z",
    fill: "#efe7ff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M113.903 48.963H96.499a.864.864 0 0 1-.864-.865v-1.044c0-.477.387-.865.864-.865h17.404c.477 0 .864.388.864.865v1.044a.864.864 0 0 1-.864.865z",
    fill: "#9049ff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M113.903 46.191H96.499a.864.864 0 0 1-.864-.864v-1.045c0-.477.387-.864.864-.864h17.404c.477 0 .864.387.864.864v1.045a.864.864 0 0 1-.864.864z",
    fill: "#6400ff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M113.903 43.418H96.499a.864.864 0 0 1-.864-.865V41.51c0-.477.387-.865.864-.865h17.404c.477 0 .864.388.864.865v1.044a.864.864 0 0 1-.864.865z",
    fill: "#9049ff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M113.903 40.644H96.499a.864.864 0 0 1-.864-.864v-1.045c0-.476.387-.864.864-.864h17.404c.477 0 .864.388.864.864v1.045a.864.864 0 0 1-.864.864z",
    fill: "#6400ff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M113.903 60.054H96.499a.864.864 0 0 1-.864-.864v-1.044c0-.477.387-.865.864-.865h17.404c.477 0 .864.388.864.865v1.044a.864.864 0 0 1-.864.864z",
    fill: "#9049ff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M113.903 57.28H96.499a.864.864 0 0 1-.864-.863v-1.045c0-.477.387-.864.864-.864h17.404c.477 0 .864.387.864.864v1.045a.864.864 0 0 1-.864.864z",
    fill: "#6400ff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M113.903 54.51H96.499a.864.864 0 0 1-.864-.865v-1.044c0-.478.387-.865.864-.865h17.404c.477 0 .864.387.864.865v1.044a.864.864 0 0 1-.864.864z",
    fill: "#9049ff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M113.903 51.736H96.499a.864.864 0 0 1-.864-.864v-1.045c0-.477.387-.864.864-.864h17.404c.477 0 .864.387.864.864v1.045a.864.864 0 0 1-.864.864z",
    fill: "#6400ff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M134.331 68.373h-17.405a.864.864 0 0 1-.864-.865v-1.044c0-.477.387-.864.864-.864h17.405c.477 0 .864.387.864.864v1.044a.864.864 0 0 1-.864.865z",
    fill: "#9049ff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M134.331 65.601h-17.405a.864.864 0 0 1-.864-.864v-1.044c0-.477.387-.865.864-.865h17.405c.477 0 .864.388.864.864v1.045a.864.864 0 0 1-.864.864z",
    fill: "#6400ff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M134.331 62.828h-17.405a.864.864 0 0 1-.864-.865V60.92c0-.477.387-.864.864-.864h17.405c.477 0 .864.387.864.864v1.044a.864.864 0 0 1-.864.865z",
    fill: "#9049ff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M134.331 60.054h-17.405a.864.864 0 0 1-.864-.864v-1.044c0-.477.387-.865.864-.865h17.405c.477 0 .864.388.864.865v1.044a.864.864 0 0 1-.864.864z",
    fill: "#6400ff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M134.331 57.28h-17.405a.864.864 0 0 1-.864-.863v-1.045c0-.477.387-.864.864-.864h17.405c.477 0 .864.387.864.864v1.045a.864.864 0 0 1-.864.864z",
    fill: "#9049ff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M134.331 54.51h-17.405a.864.864 0 0 1-.864-.865v-1.044c0-.478.387-.865.864-.865h17.405c.477 0 .864.387.864.865v1.044a.864.864 0 0 1-.864.864z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M113.903 68.373H96.499a.864.864 0 0 1-.864-.865v-1.044c0-.477.387-.864.864-.864h17.404c.477 0 .864.387.864.864v1.044a.864.864 0 0 1-.864.865z",
    fill: "#6400ff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M113.903 65.601H96.499a.864.864 0 0 1-.864-.864v-1.044c0-.477.387-.865.864-.865h17.404c.477 0 .864.388.864.864v1.045a.864.864 0 0 1-.864.864z",
    fill: "#9049ff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M113.903 62.828H96.499a.864.864 0 0 1-.864-.865V60.92c0-.477.387-.864.864-.864h17.404c.477 0 .864.387.864.864v1.044a.864.864 0 0 1-.864.865z",
    fill: "#6400ff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M32.653 60.054H15.249a.864.864 0 0 1-.864-.864v-1.044c0-.477.387-.865.864-.865h17.404c.477 0 .864.388.864.865v1.044a.864.864 0 0 1-.864.864z",
    fill: "#9049ff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M32.653 57.28H15.249a.864.864 0 0 1-.864-.863v-1.045c0-.477.387-.864.864-.864h17.404c.477 0 .864.387.864.864v1.045a.864.864 0 0 1-.864.864z",
    fill: "#6400ff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M32.653 54.51H15.249a.864.864 0 0 1-.864-.865v-1.044c0-.478.387-.865.864-.865h17.404c.477 0 .864.387.864.865v1.044a.864.864 0 0 1-.864.864z",
    fill: "#9049ff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M32.653 51.736H15.249a.864.864 0 0 1-.864-.864v-1.045c0-.477.387-.864.864-.864h17.404c.477 0 .864.387.864.864v1.045a.864.864 0 0 1-.864.864z",
    fill: "#6400ff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M53.08 68.373H35.677a.864.864 0 0 1-.864-.865v-1.044c0-.477.387-.864.864-.864h17.405c.477 0 .864.387.864.864v1.044a.864.864 0 0 1-.864.865z",
    fill: "#9049ff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M53.08 65.601H35.677a.864.864 0 0 1-.864-.864v-1.044c0-.477.387-.865.864-.865h17.405c.477 0 .864.388.864.864v1.045a.864.864 0 0 1-.864.864zM32.653 68.373H15.249a.864.864 0 0 1-.864-.865v-1.044c0-.477.387-.864.864-.864h17.404c.477 0 .864.387.864.864v1.044a.864.864 0 0 1-.864.865z",
    fill: "#6400ff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M32.653 65.601H15.249a.864.864 0 0 1-.864-.864v-1.044c0-.477.387-.865.864-.865h17.404c.477 0 .864.388.864.864v1.045a.864.864 0 0 1-.864.864z",
    fill: "#9049ff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M32.653 62.828H15.249a.864.864 0 0 1-.864-.865V60.92c0-.477.387-.864.864-.864h17.404c.477 0 .864.387.864.864v1.044a.864.864 0 0 1-.864.865z",
    fill: "#6400ff"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#home-section2-icon-1_svg__a)"
  }, /*#__PURE__*/React.createElement("path", {
    clipRule: "evenodd",
    d: "M29.375 61.565h39.377s.021 10.716 10.663 10.716H40.007s-10.632.72-10.632-10.717z",
    fill: "#d7cbe7",
    fillRule: "evenodd"
  }))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    clipRule: "evenodd",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    fill: "#d7cbe7"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M82.426 35.432H47.434a.957.957 0 0 1-.957-.957v-.067c0-.528.428-.957.957-.957h34.992c.529 0 .957.429.957.957v.068a.957.957 0 0 1-.957.956zM82.426 21.72H67.098a.958.958 0 0 1-.957-.958v-.067c0-.529.428-.957.957-.957h15.328c.529 0 .958.428.958.957v.067a.958.958 0 0 1-.958.958zM82.426 28.34H67.098a.958.958 0 0 1-.957-.957v-.067c0-.529.428-.957.957-.957h15.328c.529 0 .958.428.958.957v.067a.958.958 0 0 1-.958.958zM82.426 42.403H47.434a.958.958 0 0 1-.957-.957v-.067c0-.529.428-.957.957-.957h34.992c.529 0 .957.428.957.957v.067a.958.958 0 0 1-.957.957zM82.426 49.335H47.434a.957.957 0 0 1-.957-.957v-.068c0-.528.428-.957.957-.957h34.992c.529 0 .957.43.957.957v.068a.957.957 0 0 1-.957.957zM82.426 56.114H47.434a.957.957 0 0 1-.957-.957v-.067c0-.528.428-.957.957-.957h34.992c.529 0 .957.429.957.957v.067a.957.957 0 0 1-.957.957z"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M104.574 62.827c0 6.368-5.163 11.53-11.53 11.53-6.368 0-11.53-5.162-11.53-11.53 0-6.368 5.162-11.53 11.53-11.53 6.367 0 11.53 5.162 11.53 11.53z",
    fill: "#6400ff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M94.283 63.75c0 .772.051 1.578.034 2.367.688.084 1.394-.437 1.31-1.192-.067-.588-.772-1.024-1.344-1.175zm-2.786-2.77c.2.134.503.2.839.251v-1.897c-.739.034-1.31.336-1.192 1.091.016.168.168.42.353.555zm.906 8.075c-.05-.084-.05-.924-.067-.924-.52-.066-1.276-.184-1.796-.369-.672-.268-1.545-.554-1.83-1.259-.236-.52-.135-1.326.52-1.477.47-.135.856.386 1.26.587.503.202 1.275.387 1.846.47v-2.92c-.403-.135-.99-.253-1.293-.337-.285-.118-.52-.185-.705-.285-.47-.185-.856-.504-1.074-.89a2.618 2.618 0 0 1-.336-1.31c0-.436.1-.839.235-1.174.134-.337.369-.639.654-.874.269-.269.622-.436 1.025-.605.386-.167 1.04-.251 1.494-.301 0-.303-.05-.69.134-.94.27-.37.437-.521.873-.487.403.033.739.167.89.57.017.084.05.907.05.907.722.15 1.545.386 2.167.739.487.302.822.671.805 1.259-.017.318-.268.672-.587.705-.353.033-.672-.185-.957-.335-.386-.17-.924-.404-1.428-.454v2.317c.47.134 1.042.386 1.411.537 1.243.503 1.847 1.746 1.796 3.005a3.18 3.18 0 0 1-.252 1.176 3.13 3.13 0 0 1-.67.806c-.27.235-.589.403-.958.57-.37.118-.89.219-1.327.303-.05 0-.016.688 0 .755 0 .168-.05.37-.117.487-.42.588-1.578.52-1.763-.252z",
    fill: "#fff"
  }))));
};
export default SvgHomeSection2Icon1;